import AnalyticsIcon from "@mui/icons-material/Analytics";
import BusinessIcon from "@mui/icons-material/Business";
import GroupsIcon from "@mui/icons-material/Groups";
import CampaignIcon from "@mui/icons-material/Campaign";
import MiscellaneousServicesIcon from "@mui/icons-material/MiscellaneousServices";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import LocationCityIcon from "@mui/icons-material/LocationCity";
import FingerprintIcon from "@mui/icons-material/Fingerprint";
import CoPresentIcon from "@mui/icons-material/CoPresent";
import ArrowCircleUpIcon from "@mui/icons-material/ArrowCircleUp";
import GroupWorkIcon from "@material-ui/icons/GroupWork";
import AppRegistrationIcon from "@mui/icons-material/AppRegistration";
import FilterNoneIcon from "@mui/icons-material/FilterNone";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import DifferenceIcon from "@mui/icons-material/Difference";
import SafetyDividerIcon from "@mui/icons-material/SafetyDivider";
import FeedIcon from "@mui/icons-material/Feed";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import SentimentSatisfiedAltIcon from "@mui/icons-material/SentimentSatisfiedAlt";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import SpeedIcon from '@mui/icons-material/Speed';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import SendIcon from '@mui/icons-material/Send';
import DescriptionIcon from '@mui/icons-material/Description';
import AssignmentIcon from "@mui/icons-material/Assignment";
import { CalendarIcon } from "@mui/x-date-pickers";
import SchoolIcon from "@material-ui/icons/School";
import ChartSquareBarIcon from "../../icons/ChartSquareBar";
import UsersIcon from "../../icons/Users";

export const sections3 = [
    {
      title: "Général",
      items: [
        {
          title: "Tableau de bord",
          path: "/dashboard",
          icon: <ChartSquareBarIcon fontSize="small" />,
        },
      ],
    },
    {
      title: "Qualité",
      items: [
        {
          title: "Tickets d'incidents",
          path: "/dashboard/tickets",
          icon: <ConfirmationNumberIcon fontSize="small" />,
        },
        {
          title: "Réclamations",
          path: "/dashboard/complaint",
          icon: <PriorityHighIcon fontSize="small" />,
        },
      ],
    },
    {
      title: "Gestion",
      items: [
        {
          title: "Apprenants",
          path: "/dashboard/customers",
          icon: <UsersIcon fontSize="small" />,
        },
        {
          title: "Prospects",
          path: "/dashboard/prospects",
          icon: <SafetyDividerIcon fontSize="small" />,
        },
        {
          title: "Calendrier",
          path: "/dashboard/calendar",
          icon: <CalendarIcon fontSize="small" />,
        },
        {
          title: "Campagne",
          path: "/dashboard/campaign",
          icon: <CampaignIcon fontSize="small" />,
        },
      ],
    },
    {
      title: "Pédagogie",
      items: [
        {
          title: "Formations",
          path: "/dashboard/formations",
          icon: <SchoolIcon fontSize="small" />,
        },
        {
          title: "Sessions",
          path: "/dashboard/formationSession",
          icon: <FilterNoneIcon fontSize="small" />,
        },
        {
          title: "Intervenants",
          path: "/dashboard/intervenants",
          icon: <CoPresentIcon fontSize="small" />,
        },
        {
          title: "Suivi des tâches",
          path: "/dashboard/tasks-tracking",
          icon: <AssignmentIcon fontSize="small" />,
        },
        {
          title: "Suivi inscrits/désinscrits",
          path: "/dashboard/learners-tracking",
          icon: <AppRegistrationIcon fontSize="small" />,
        },
      ],
    },
  ];
  
 export const sections2 = [
    {
      title: "Général",
      items: [
        {
          title: "Tableau de bord",
          path: "/dashboard",
          icon: <ChartSquareBarIcon fontSize="small" />,
        },
      ],
    },
    {
      title: "Qualité",
      items: [
        {
          title: "Tickets d'incidents",
          path: "/dashboard/tickets",
          icon: <ConfirmationNumberIcon fontSize="small" />,
        },
        {
          title: "Réclamations",
          path: "/dashboard/complaint",
          icon: <PriorityHighIcon fontSize="small" />,
        },
      ],
    },
    {
      title: "Gestion",
      items: [
        {
          title: "Apprenants",
          path: "/dashboard/customers",
          icon: <UsersIcon fontSize="small" />,
        },
        {
          title: "Prospects",
          path: "/dashboard/prospects",
          icon: <SafetyDividerIcon fontSize="small" />,
        },
        {
          title: "Calendrier",
          path: "/dashboard/calendar",
          icon: <CalendarIcon fontSize="small" />,
        },
        {
          title: "Campagne",
          path: "/dashboard/campaign",
          icon: <CampaignIcon fontSize="small" />,
        },
        {
          title: "Relance",
          path: "/dashboard/relaunch",
          icon: <ArrowCircleUpIcon fontSize="small" />,
        },
        // {
        //   title: "Qualité",
        //   path: "/dashboard/quality",
        //   icon: <CheckIcon fontSize="small" />,
        // },
      ],
    },
    {
      title: "Pédagogie",
      items: [
        {
          title: "Formations",
          path: "/dashboard/formations",
          icon: <SchoolIcon fontSize="small" />,
        },
        {
          title: "Sessions",
          path: "/dashboard/formationSession",
          icon: <FilterNoneIcon fontSize="small" />,
        },
        {
          title: "Intervenants",
          path: "/dashboard/intervenants",
          icon: <CoPresentIcon fontSize="small" />,
        },
        {
          title: "Suivi des tâches",
          path: "/dashboard/tasks-tracking",
          icon: <AssignmentIcon fontSize="small" />,
        },
        {
          title: "Suivi inscrits/désinscrits",
          path: "/dashboard/learners-tracking",
          icon: <AppRegistrationIcon fontSize="small" />,
        },
      ],
    },
    {
      title: "Paramètres",
      items: [
        {
          title: "Notifications emails",
          path: "/dashboard/email-notifications",
          icon: <SendIcon fontSize="small" />,
        },
      ],
    },
  ];
  
export  const sectionsAdmin = [
    {
      items: [
        {
          title: "Tableau de bord",
          path: "/dashboard",
          icon: <ChartSquareBarIcon fontSize="small" />,
        },
      ],
    },
    {
      title: "Commercial",
      items: [
        {
          title: "Apprenants",
          path: "/dashboard/customers",
          icon: <UsersIcon fontSize="small" />,
        },
        {
          title: "Prospects",
          path: "/dashboard/prospects",
          icon: <SafetyDividerIcon fontSize="small" />,
        },
        {
          title: "Calendrier",
          path: "/dashboard/calendar",
          icon: <CalendarIcon fontSize="small" />,
        },
        {
          title: "Établissements",
          path: "/dashboard/etablissements",
          icon: <BusinessIcon fontSize="small" />,
        },
        {
          title: "Groupements",
          // path: '/dashboard/groupements',
          icon: <GroupsIcon fontSize="small" />,
        },
        {
          title: "Campagne",
          path: "/dashboard/campaign",
          icon: <CampaignIcon fontSize="small" />,
        },
        {
          title: 'Relance',
          path: '/dashboard/relaunch',
          icon: <ArrowCircleUpIcon fontSize="small" />
        }
      ]
    },
    {
      title: "Qualité",
      items: [
        {
          title: "Tickets d'incidents",
          path: "/dashboard/tickets",
          icon: <ConfirmationNumberIcon fontSize="small" />,
        },
        {
          title: "Réclamations",
          path: "/dashboard/complaint",
          icon: <PriorityHighIcon fontSize="small" />,
        },
        {
          title: "Satisfaction",
          path: "/dashboard/satisfactions",
          icon: <SentimentSatisfiedAltIcon fontSize="small" />,
        },
        {
          title: "Performance",
          path: "/dashboard/performances",
          icon: <SpeedIcon fontSize="small" />,
        },
        {
          title: "Questionnaire",
          path: "/dashboard/questionnaire-formation",
          icon: <DescriptionIcon fontSize="small" />,
        },
        {
          title: "Suivi des réponses",
          path: "/dashboard/questionnaire-satisfaction",
          icon: <FeedIcon fontSize="small" />,
        },
      ],
    },
    {
      title: "Gestion",
      items: [
        {
          title: "Partenaires",
          path: "/dashboard/partners",
          icon: <GroupWorkIcon fontSize="small" />,
        },
      ],
    },
    {
      title: "Pédagogie",
      items: [
        {
          title: "Formations",
          path: "/dashboard/formations",
          icon: <SchoolIcon fontSize="small" />,
        },
        {
          title: "Sessions",
          path: "/dashboard/formationSession",
          icon: <FilterNoneIcon fontSize="small" />,
        },
        {
          title: "Intervenants",
          path: "/dashboard/intervenants",
          icon: <CoPresentIcon fontSize="small" />,
        },
        {
          title: "Suivi des tâches",
          path: "/dashboard/tasks-tracking",
          icon: <AssignmentIcon fontSize="small" />,
        },
        {
          title: "Suivi inscrits/désinscrits",
          path: "/dashboard/learners-tracking",
          icon: <AppRegistrationIcon fontSize="small" />,
        },
        {
          title: "Concepteur",
          path: "",
          icon: <PersonOutlineIcon fontSize="small" />,
        },
      ],
    },
    {
      title: "Rapport",
      items: [
        {
          title: "Analyse",
          path: "/dashboard/analysis",
          icon: <AnalyticsIcon />,
        },
        {
          title: "Rapports personnalisés",
          path: "custom-reports",
          icon: <AppRegistrationIcon fontSize="small" />,
        },
        {
          title: "Suivi des apprenants",
          path: "/dashboard/shift",
          icon: <DifferenceIcon fontSize="small" />,
        },
      ],
    },
    {
      title: "Ressources humaines",
      items: [
        {
          title: "Salarié",
          path: "",
          icon: <GroupsIcon fontSize="small" />,
        },
        {
          title: "Services",
          path: "",
          icon: <CoPresentIcon fontSize="small" />,
        },
        {
          title: "Présences",
          path: "",
          icon: <FingerprintIcon fontSize="small" />,
        },
      ],
    },
    {
      title: "Paramètres",
      items: [
        {
          title: "Activités",
          path: "/dashboard/logs",
          icon: <FeedIcon fontSize="small" />,
        },
        {
          title: "Utilisateurs",
          path: "/dashboard/users",
          icon: <ManageAccountsIcon fontSize="small" />,
        },
        {
          title: "Notifications emails",
          path: "/dashboard/email-notifications",
          icon: <SendIcon fontSize="small" />,
        },
        {
          title: "Droits",
          path: "",
          icon: <MiscellaneousServicesIcon fontSize="small" />,
        },
        {
          title: "Multi-Établissements",
          path: "",
          icon: <LocationCityIcon fontSize="small" />,
        },
        {
          title: "Notes de versions",
          path: "/dashboard/version-notes",
          icon: <DescriptionIcon fontSize="small" />,
        },
      ],
    },
  ];
  
export  const sections4 = [
    {
      title: "Général",
      items: [
        {
          title: "Tableau de bord",
          path: "/dashboard",
          icon: <ChartSquareBarIcon fontSize="small" />,
        },
      ],
    },
    {
      title: "Qualité",
      items: [
        {
          title: "Tickets d'incidents",
          path: "/dashboard/tickets",
          icon: <ConfirmationNumberIcon fontSize="small" />,
        },
        {
          title: "Réclamations",
          path: "/dashboard/complaint",
          icon: <PriorityHighIcon fontSize="small" />,
        },
      ],
    },
    {
      title: "Gestion",
      items: [
        {
          title: "Apprenants",
          path: "/dashboard/customers",
          icon: <UsersIcon fontSize="small" />,
        },
        {
          title: "Prospects",
          path: "/dashboard/prospects",
          icon: <SafetyDividerIcon fontSize="small" />,
        },
        {
          title: "Calendrier",
          path: "/dashboard/calendar",
          icon: <CalendarIcon fontSize="small" />,
        },
        {
          title: "Relance",
          path: "/dashboard/relaunch",
          icon: <ArrowCircleUpIcon fontSize="small" />,
        },
        // {
        //   title: "Qualité",
        //   path: "/dashboard/quality",
        //   icon: <CheckIcon fontSize="small" />,
        // },
      ],
    },
    {
      title: "Pédagogie",
      items: [
        {
          title: "Formations",
          path: "/dashboard/formations",
          icon: <SchoolIcon fontSize="small" />,
        },
        {
          title: "Sessions",
          path: "/dashboard/formationSession",
          icon: <FilterNoneIcon fontSize="small" />,
        },
        {
          title: "Intervenants",
          path: "/dashboard/intervenants",
          icon: <CoPresentIcon fontSize="small" />,
        },
        {
          title: "Suivi des tâches",
          path: "/dashboard/tasks-tracking",
          icon: <AssignmentIcon fontSize="small" />,
        },
        {
          title: "Suivi inscrits/désinscrits",
          path: "/dashboard/learners-tracking",
          icon: <AppRegistrationIcon fontSize="small" />,
        },
      ],
    },
    {
      title: "Rapport",
      items: [
        {
          title: "Analyse",
          path: "/dashboard/analysis",
          icon: <AnalyticsIcon />,
        },
        {
          title: "Suivi des apprenants",
          path: "/dashboard/shift",
          icon: <DifferenceIcon fontSize="small" />,
        },
      ],
    },
    {
      title: "Paramètres",
      items: [
        {
          title: "Notifications emails",
          path: "/dashboard/email-notifications",
          icon: <SendIcon fontSize="small" />,
        },
      ],
    },
  ];
